import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "layout/DashboardLayout";
import AuthLayout from "layout/AuthLayout"; 
import Login from "pages/Auth/Login";
import Reset from "pages/Auth/Reset"
import Verification from "pages/Auth/Verification";
import PasswordReset from "pages/Auth/PasswordReset";
import Timezone from "pages/Timezone";

// Lazy load pages
const Dashboard = lazy(() => import("pages/Dashboard"));
const ListingPage = lazy(() => import("pages/UserListing/ListingPage"));
const Application = lazy(() => import("pages/Application"));


const routes = [
  {
    path: "/",
    element: <Navigate to="/dashboard"  />,
  },
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "reset",
        element: <Reset/>,
      },
      {
        path: "verification",
        element: <Verification />,
      },
      {
        path: "password_reset",
        element: <PasswordReset />,
      },
    ],
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "listing",
        element: <ListingPage />,
      },
      {
        path: "application",
        element: <Application />,
      },
      {
        path:"timezone",
        element:<Timezone/>,
      }
    ],
  },
];

export default routes;
